'use strict';
const { createAddQueries } = require('../addQueries');
const {
  id,
  payerId,
  recipientId,
  createFilterConfig,
} = require('./commons');

module.exports = createAddQueries({
  baseUrl: ({ fspId }) => `/fsps/${fspId}/recipientgroups`,
  returnModel: {
    name: 'recipientgroups',
  },
  finders: [
    id,
    payerId,
    recipientId,
    createFilterConfig('groupName', 'groupname', 'string'),
  ],
  orderBy: [
    id,
    payerId,
    recipientId,
    createFilterConfig('groupName', 'groupname', 'string'),
  ],
});
